import WidgetEventInformationResourceModel from '../../generated/types/model/resource/WidgetEventInformationResourceModel';

export default class WidgetEventInformationResourceViewModel extends WidgetEventInformationResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
